

























import BaseComponent from '@/components/base-component.vue';
import UiFilterContainer from '@/components/UI/filter-container.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectSortOptions from '@/components/UI/select-sort-options.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {
    PermissionAuth,
    UiFilterContainer,
    UiSelectSortOptions
  }
})
export default class ContactFilters extends BaseComponent {
  @Prop()
  public menuMode?: boolean;

  filter: any = {};

  descending = false;
  sortBy = 'nome';
  sortOptions = [];

  mounted() {
    this.buildSortOptions();
  }

  buildSortOptions() {
    this.descending = false;
    this.sortBy = 'nome';
    this.sortOptions = [];
    this.sortOptions.push({ text: 'Nome', value: 'nome' });
  }

  onSortChange(by, desc) {
    this.sortBy = by;
    this.descending = desc;
  }

  onChangeFilter() {
    if (this.menuMode) {
      return;
    }

    this.filter.oldTextoBusca = this.filter.textoBusca;
    this.emitFilter();
  }

  emitFilter() {
    if (this.menuMode) {
      this.filter.descending = this.descending;
      this.filter.sortBy = this.sortBy;
    } else {
      this.filter.sortBy = null;
    }
    this.$emit('filter', this.filter);
  }
}
